import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _SortUpLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", d: "M5 16h8M5 12h6M5 8h4" }),
            React.createElement("path", { stroke: "currentColor", d: "m16 9 3-3 3 3m-3-3v12" })));
}
const SortUpLight = forwardRef(_SortUpLight);
export { SortUpLight };
